<template>
  <div class="headFixed freshAirDetail eq-panel" @click="hideSomething">
    <div class="detail_head fixed_head">
      <div class="">
        <div class="content">
          <div class="go_back">
            <span @click="goBack" class="goBackBtn"></span>
            {{ eqInfo ? eqInfo.equipmentName : '' }}
            <img v-show="eqInfo&&!firstRequest" @click="changeMenu" class="right menuImg" width="25"
                 src="../../../assets/images/menu.png" alt="">
          </div>
        </div>
      </div>
      <div class="menu" v-show="showMenu">
        <ul>
          <router-link :to="'/equipment/info/'+this.getId()">
            <li>设备信息</li>
          </router-link>
          <li @click="eqUnbind">解除绑定</li>
        </ul>
      </div>
    </div>
    <div class="noInfo" v-show="showEmpty">
      暂无信息
    </div>
    <div v-show="!isRequest">
      <div class="eqInfoDetail" v-show="eqInfo">
        <div>
          <div class="detail_top">
            <div class="degrees yuan">
              <div class="yuanItem">{{ zhiliang }}</div>
              <p :class="this.drawDegree==null?'noDegree':''">
                <span>{{ eqParams && eqParams.pm25 ? eqParams.pm25 : 0 }}</span>
                <span class="type"><span>PM2.5</span></span>
              </p>
            </div>
            <div class="humidity font">
              <span>CO2</span>
              <span>{{ eqParams && eqParams.co2 ? eqParams.co2 : 0 }}ppm</span>

            </div>
          </div>
          <div class="fresh_img"></div>
        </div>

        <!--        环境空气质量-->
        <p class="contentTitle">环境空气质量</p>
        <div class="contentBox">
          <div>
            <p>温度</p>
            <p class="aText text-danger"><span
                class="span-font">{{ eqParams && eqParams.temperature ? eqParams.temperature : 0 }}</span>℃</p>
          </div>
          <div>
            <p>湿度</p>
            <p class="text-success"><span class="span-font">{{
                eqParams && eqParams.humidity ? eqParams.humidity : 0
              }}</span>%
            </p>
          </div>
          <div>
            <p>HCHO</p>
            <p class=" text-blue"><span
                class="span-font">{{ eqParams && eqParams.hcho ? eqParams.hcho : 0 }}</span>mg</p>
          </div>
          <div>
            <p>C6H6</p>
            <p class="text-orange"><span class="span-font">{{ eqParams && eqParams.c6h6 ? eqParams.c6h6 : 0 }}</span>mg/m³
            </p>
          </div>
          <div>
            <p>TVOC</p>
            <p class="text-success"><span class="span-font">{{ eqParams && eqParams.tvoc ? eqParams.tvoc : 0 }}</span>mg/m³
            </p>
          </div>
          <div>
            <p>PM10</p>
            <p class="text-danger"><span class="span-font">{{ eqParams && eqParams.pm10 ? eqParams.pm10 : 0 }}</span>mg/m³
            </p>
          </div>
        </div>
      </div>
    </div>

    <!--解绑弹窗-->
    <div class="tip detail_tip" v-show="showUnBind">
      <div class="content">
        <div class="tip_body">
          <div class="modal-warning">
            <span></span>
            <p>温馨提示：确定解除绑定吗</p>
          </div>

        </div>
        <div class="tip_foot">
          <span @click="hideModalCom('showUnBind')">取消</span>
          <span @click="sureBind">确定</span>
        </div>
      </div>
    </div>

    <div class="userParams eq-shandow">
      <p>场景
        <span class=" right yh">
	      <span class="yh2">{{ eqInfo.sceneName }}</span>  {{ eqInfo.roomName }}
	      <i class="icon-edit" @click="chooseScene"></i>
	  </span></p>
    </div>

  </div>
</template>
<script>
import {Range, Toast, Popup, Radio, Indicator, Progress} from 'mint-ui';
import PATH from '../../../router/path'

export default {
  name: 'detail',
  data() {
    return {
      zhiliang: "暂无",
      rangeValue: 50,
      showRange: false,
      list: [],
      showMenu: false,
      showTip: false,
      eqId: this.$route.params.id,
      totalDegree: 45,
      eqInfo: {
        coolInWaterTemerature: null,
        coolOutWaterTemerature: null,
        createTime: null,
        equipmentCoolTemperature: null,
        equipmentFanMode: null,
        equipmentHeatTemperature: null,
        equipmentMode: null,
        equipmentName: null,
        equipmentNumber: null,
        equipmentPassword: null,
        temperature: null,
        equipmentStatus: null,
        deviceType: null,
        id: null,
        ids: null,
        isAlarm: null,
        repairRecord: null,
        room: null,
        roomId: null,
        sendInWaterTemerature: null,
        sendOutWaterTemerature: null,
        updateTime: null,
        useScene: null,
        useSceneId: null,
        userId: null,
        sceneId: null
      },
      eqModeVal: null,
      type: 1,
      equipmentFanMode: 1,//(1:on 0:自动 2:循环 3: 低速 4: 中速 5: 高速)
      degrees: 0,
      popupVisible: false,
      eqFlag: 1,
      stopRequest: false,
      showModel: false,
      alreadyLoad: false,
      value: '2',
      showDegrees: false,
      valueDegrees: null,
      roomTep: null,
      firstRequest: true,
      isRequest: true,
      showEmpty: false,
      showUnBind: false,

      path: this.$websocketUrl,
      // path: "ws://www.192.168.1.103:80/auto-equipment/websocketDemo/",
      socket: "",
      drawDegree: null,
      showFreshDegrees: false,
      eqParams: {}
    }
  },
  beforeMount() {
    let num = this.totalDegree;
    let list = [];
    for (let i = 0; i < num; i++) {
      list.push(i);
    }
    this.list = list;
  },
  mounted() {
    this.isRequest = true;
    this.closeTimer = null;
    // this.drawDegree = null;
    if (this.closeTimer) {
      clearInterval(this.closeTimer);
    }
    this.init();
  },
  beforeDestroy() {
    this.stopRequest = true;
    this.socketclose();
  },
  methods: {
    init() {
      // this.drawCircle();
      if (this.getId()) {
        this.eqDetail(this.eqId);
        //   this.getFreshEquipmentDetail();
      }
    },
    getId() {
      return this.$route.params.id;
    },

    initDraw() {
      let degrees = this.drawDegree;
      if (degrees || degrees == 0) {
        // this.drawPointer(degrees);
        // this.drawGreenCricle(degrees);
        // this.drawCircle(degrees);
      }
    },
    eqDetail(id) {
      let self = this;
      if (this.firstRequest) {
        Indicator.open({
          spinnerType: 'fading-circle'
        });
      }
      this.Api.eqDetail(id, (msg) => {
        self.eqInfo = msg.data;

        //初始化websocket
        if (typeof (WebSocket) === "undefined") {
          alert("您的浏览器不支持socket")
        } else {
          this.socket = this.$store.state.websocket
          if (!this.socket) {
            this.socket = new WebSocket(this.$websocketUrl + this.eqInfo.iotDeviceId);
          }
          // 监听socket连接
          this.socket.onopen = this.socketopen
          // 监听socket错误信息
          this.socket.onerror = this.socketerror
          // 监听socket消息
          this.socket.onmessage = this.getMessage
          // 关闭socket消息
          this.socket.onclose = this.socketclose
          this.$store.commit('setWebSocket', this.socket);
        }

        this.alreadyLoad = true;
        Indicator.close();
        this.firstRequest = false;
        this.isRequest = false;
        if (msg.data) {
          var data = msg.data;
          self.type = msg.data.deviceType;
          self.degrees = msg.data.detector.temperature;
          this.eqParams = msg.data.detector
          if (this.eqParams.pm25 <= 35 && this.eqParams.pm25 >= 0) {
            this.zhiliang = "优"
          } else if (this.eqParams.pm25 <= 75 && this.eqParams.pm25 > 35) {
            this.zhiliang = "良"
          } else if (this.eqParams.pm25 <= 115 && this.eqParams.pm25 > 75) {
            this.zhiliang = "轻度污染"
          } else if (this.eqParams.pm25 <= 150 && this.eqParams.pm25 > 115) {
            this.zhiliang = "中度污染"
          } else if (this.eqParams.pm25 <= 250 && this.eqParams.pm25 > 150) {
            this.zhiliang = "重度污染"
          } else if (this.eqParams.pm25 > 250) {
            this.zhiliang = "严重污染"
          } else {
            this.zhiliang = "暂无"
          }

        } else {
          this.showEmpty = true;
        }
      }, () => {
        this.alreadyLoad = true;
        Indicator.close();
        this.isRequest = true;
        this.showEmpty = true;
      })
    },
    eqDel() {
      let params = {};
      params.id = this.eqId;
      this.Api.eqDel(params, (msg) => {
        if (msg.code == 200) {
          let str = 'pageNo=1';
          this.eqList(str);
        } else {
          Toast(msg.message)
        }
      })
    },

    hideSomething() {
      this.showRange = false;
      this.showMenu = false;
    },
    changeMenu(e) {
      e.stopPropagation();
      this.showMenu = !this.showMenu;
    },
    eqUnbind() {
      this.showModalCom('showUnBind')
    },
    sureBind() {
      let data = {
        "iotDeviceId": this.getId()
      }
      this.Api.eqUnbind(data, (msg) => {
        this.showUnBind = false;
        if (msg.code == 200) {
          localStorage.setItem('isLo', 1);
          Toast('设备解绑成功');
          this.$router.push({path: '/equipment'})
        }
        if (msg.code == 402) {
          Toast(msg.message);
        }
      })
    },
    goBack() {
      this.$router.push({path: '/equipment'})
    },
    hideModalCom(key) {
      this.showUnBind = false;
    },
    showModalCom(key) {
      this[key] = true;
    },
    socketopen: function () {
      console.log("socket连接成功")
    },
    socketerror: function () {
      console.log("连接错误")
    },
    socketclose: function () {
      console.log("socket已经关闭")
      this.socket.close()
    },
    chooseScene() {
      this.$router.push({path: this.PATH.getChooseHome() + '2?id=' + this.getId()})
    },
    getMessage: function (msg) {
      let data = JSON.parse(msg.data);
      if (data.pm25) {
        this.eqParams.pm25 = data.pm25
        if (this.eqParams.pm25 <= 35 && this.eqParams.pm25 >= 0) {
          this.zhiliang = "优"
        } else if (this.eqParams.pm25 <= 75 && this.eqParams.pm25 > 35) {
          this.zhiliang = "良"
        } else if (this.eqParams.pm25 <= 115 && this.eqParams.pm25 > 75) {
          this.zhiliang = "轻度污染"
        } else if (this.eqParams.pm25 <= 150 && this.eqParams.pm25 > 115) {
          this.zhiliang = "中度污染"
        } else if (this.eqParams.pm25 <= 250 && this.eqParams.pm25 > 150) {
          this.zhiliang = "重度污染"
        } else if (this.eqParams.pm25 > 250) {
          this.zhiliang = "严重污染"
        } else {
          this.zhiliang = "暂无"
        }
      }
      if (data.hcho) {
        this.eqParams.hcho = data.hcho;
      }
      if (data.temperature) {
        this.eqParams.temperature = data.temperature;
      }
      if (data.humidity) {
        this.eqParams.humidity = data.humidity;
      }
      if (data.c6h6) {
        this.eqParams.c6h6 = data.c6h6;
      }
      if (data.tvoc) {
        this.eqParams.tvoc = data.tvoc;
      }
      if (data.pm10) {
        this.eqParams.pm10 = data.pm10;
      }
    },
  }
}
</script>
<style scoped>
@import url('../../../assets/list.css');
@import url('../../equipment/detail/detail.css');
@import url('../detail/index.css');

.noDegree {
  font-size: 80px !important;
}

.yh-item {
  padding-top: 5px;
  text-align: center;
  color: #FFFFFF;
  font-size: 14px;
}

.yh {
  display: inline-block;
  max-width: 85%;
  text-align: right;
}

.yh2 {
  display: inline-block;
  max-width: 60%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.yuan {
  box-shadow: 40px -40px 60px rgba(240, 255, 255, 0.8) inset;
  border-radius: 50%;
  animation: yuanD 15s linear infinite;
}

.yuanItem {
  line-height: 300px;
}

.pm25 {
  color: orange;
}

@keyframes yuanD {
  0% {
    box-shadow: 40px -40px 60px rgba(240, 255, 255, 0.8) inset;
  }
  50% {
    box-shadow: 40px 40px 60px rgba(240, 255, 255, 0.8) inset;
  }
  100% {
    box-shadow: 40px -40px 60px rgba(240, 255, 255, 0.8) inset;
  }

}

.contentTitle {
  margin: 20px 20px 10px;
  line-height: 40px;
  text-align: center;
  border-radius: 5px;
  box-shadow: 0px 1px 2px #aaa;
  background-image: linear-gradient(45deg, #eee, #fff, #eee);
}

.contentBox {
  box-sizing: border-box;
  margin: 10px;
}

.contentBox div {
  display: inline-block;
  width: 45%;
  box-sizing: border-box;
  margin: 5px;
  border-radius: 5px;
  background-image: linear-gradient(45deg, #eee, #fff, #eee);
  box-shadow: 0px 1px 2px #aaa;
}

.contentBox div p {
  display: inline-block;
  line-height: 44px;
}

.contentBox div p:first-child {
  box-sizing: border-box;
  padding-left: 8px;
  text-align: left;
  /* font-size: 16px; */
  letter-spacing: 0px;
}

.contentBox div p:last-child {
  float: right;
  padding-right: 6px;
  font-size: 10px;
  text-align: right;
  letter-spacing: 0px;
}

.span-font {
  font-size: 18px;
}

.font {
  font-size: 20px;
}
</style>




// WEBPACK FOOTER //
// src/components/freshAir/status/status6.vue